import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { Logo } from "../login/login.styled";
import { laptop } from "../../media";

/* ───────────────── layout ───────────────── */
// registration.styled.ts
export const Wrapper = styled.div<{ bg: string; $fill: boolean }>`
  ${({ $fill }) =>
  $fill
    ? `
          min-height: 100%;
          height: auto;
        `
    : `
          min-height: 100%;
          height: 100%;
        `}

  width: 100%;            /* ✅ ensure full viewport width */
  overflow-x: hidden;      /* ✅ stops the white strip during x-translate */
  background: ${({ bg }) => bg};

  padding: max(env(safe-area-inset-top, 0px), 24px) 32px max(env(safe-area-inset-bottom, 0px), 24px);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

export const Container = styled(motion.div)<{
  $align: string;
  $justify: string;
}>`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  /* NEW — dynamic flex props */
  align-items: ${(p) => p.$align};
  justify-content: ${(p) => p.$justify};

  max-height: 1080px;
  flex: 1;

  ${laptop`
    max-width: 600px;
  `}
`;

/* ───────────────── logo image ───────────────── */
export const ShellLogoImg = styled(Logo, {
  shouldForwardProp: (prop) => prop !== "small",
})<{ small: boolean }>`
  height: ${({ small }) => (small ? 22 : 38)}px;
  width: auto;
`;
